import { initValidatedForm } from '../components/form-validation.js';

(function () {
    initLoginForm();
    initForgotPasswordForm();
    initRegisterForm();
    initResetPasswordForm();
})();

export function initLoginForm(documentRef = globalThis.document) {
    const form = documentRef?.querySelector?.('[data-auth-login-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const emailInput = form.querySelector('input[name="email"]');
    const passwordInput = form.querySelector('input[name="password"]');

    if (!(emailInput instanceof HTMLInputElement) || !(passwordInput instanceof HTMLInputElement)) {
        return;
    }

    initValidatedForm({
        form,
        fields: [
            buildUiFieldConfig(emailInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Enter a valid email address.',
                typeMismatch: 'Enter a valid email address.',
            }),
            buildUiFieldConfig(passwordInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Password is required.',
            }),
        ],
    });
}

export function initRegisterForm(documentRef = globalThis.document) {
    const form = documentRef?.querySelector?.('[data-auth-register-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const emailInput = form.querySelector('input[name="email"]');
    const passwordInput = form.querySelector('input[name="password"]');
    const confirmPasswordInput = form.querySelector('input[name="confirm_password"]');

    if (
        !(emailInput instanceof HTMLInputElement)
        || !(passwordInput instanceof HTMLInputElement)
        || !(confirmPasswordInput instanceof HTMLInputElement)
    ) {
        return;
    }

    initValidatedForm({
        form,
        fields: [
            buildUiFieldConfig(emailInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Enter a valid email address.',
                typeMismatch: 'Enter a valid email address.',
            }),
            buildUiFieldConfig(passwordInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Password is required.',
                tooShort: 'Password must be at least 8 characters.',
            }),
            buildUiFieldConfig(confirmPasswordInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Confirm your password.',
            }, () => {
                if (confirmPasswordInput.value === '') {
                    return '';
                }

                return passwordInput.value === confirmPasswordInput.value
                    ? ''
                    : 'Passwords do not match.';
            }),
            ...buildTermsConsentFieldConfigs(form),
        ],
    });
}

function buildTermsConsentFieldConfigs(form) {
    const input = form.querySelector('input[name="accept_terms"]');
    const container = input?.closest?.('.ui-form-field');
    if (!(input instanceof HTMLInputElement) || !(container instanceof HTMLElement)) {
        return [];
    }

    return [{
        input,
        errorContainer: container,
        errorElement: container.querySelector('.auth-inline-error.ui-form-error'),
        errorClassName: 'auth-inline-error ui-form-error',
        messages: {
            valueMissing: 'Accept the Terms to create an account.',
        },
    }];
}

export function initForgotPasswordForm(documentRef = globalThis.document) {
    const form = documentRef?.querySelector?.('[data-auth-forgot-password-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const emailInput = form.querySelector('input[name="email"]');
    if (!(emailInput instanceof HTMLInputElement)) {
        return;
    }

    initValidatedForm({
        form,
        fields: [
            buildUiFieldConfig(emailInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Enter a valid email address.',
                typeMismatch: 'Enter a valid email address.',
            }),
        ],
    });
}

export function initResetPasswordForm(documentRef = globalThis.document) {
    const form = documentRef?.querySelector?.('[data-auth-reset-password-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const passwordInput = form.querySelector('input[name="password"]');
    const confirmPasswordInput = form.querySelector('input[name="confirm_password"]');

    if (
        !(passwordInput instanceof HTMLInputElement)
        || !(confirmPasswordInput instanceof HTMLInputElement)
    ) {
        return;
    }

    initValidatedForm({
        form,
        fields: [
            buildUiFieldConfig(passwordInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Password is required.',
                tooShort: 'Password must be at least 8 characters.',
            }),
            buildUiFieldConfig(confirmPasswordInput, 'auth-inline-error ui-form-error', {
                valueMissing: 'Confirm your new password.',
            }, () => {
                if (confirmPasswordInput.value === '') {
                    return '';
                }

                return passwordInput.value === confirmPasswordInput.value
                    ? ''
                    : 'Passwords do not match.';
            }),
        ],
    });
}

function buildUiFieldConfig(input, errorClassName, messages, getCustomMessage = null) {
    return {
        input,
        errorContainer: input.parentElement,
        errorElement: input.parentElement?.querySelector?.(`.${errorClassName.split(' ').join('.')}`) ?? null,
        errorClassName,
        messages,
        getCustomMessage,
    };
}
